// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"beh_a bhf_bk bhf_bl bhf_bo","SwipeLeftToClose--animating":"beh_b"};